/* eslint-disable */
// src/services/axiosConfig.js

/* 
 * Instancia configurada de axios (baseURL, headers, interceptores si aplica).
 * Usada por todos los servicios para homogenizar llamadas HTTP.
 */

import axios from 'axios';
import { getCurrentRole, getCurrentUsername } from "utils/auth";

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';
const instance = axios.create({ baseURL, withCredentials: true });

instance.interceptors.request.use(cfg => {
  const t = localStorage.getItem('token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

instance.interceptors.response.use(
  r => r,
  async err => {
    const orig = err.config;
    const isDeviceNotAuthorized =
      err.response?.status === 403 &&
      (err.response?.data?.code === "DEVICE_NOT_AUTHORIZED" ||
        err.response?.data?.error === "DEVICE_NOT_AUTHORIZED");

    if (isDeviceNotAuthorized) {
      console.warn("[axios] device_not_authorized", {
        path: window.location.pathname,
      });
      if (window.location.pathname !== "/authorized-device-status") {
        window.location.href = "/authorized-device-status";
      }
      return Promise.reject(err);
    }

    const requestUrl = orig?.url || "";
    const isRefreshEndpoint =
      requestUrl.includes("/refresh/refresh-token") ||
      requestUrl.includes("/refresh/logout");

    if (err.response?.status === 401 && isRefreshEndpoint) {
      console.warn("[axios] refresh_failed_clearing_local_session", {
        status: err?.response?.status,
        message: err?.response?.data?.message,
      });
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("username");
      if (window.location.pathname !== "/authentication/sign-in") {
        window.location.href = "/authentication/sign-in";
      }
      return Promise.reject(err);
    }

    if (err.response?.status === 401 && !orig._retry) {
      orig._retry = true;
      try {
        // Usa la MISMA instancia (respeta baseURL y demás interceptores)
        const refreshResp = await instance.post(
          '/refresh/refresh-token',
          {},
          { headers: { Authorization: orig.headers.Authorization } }
        );
        const newT = refreshResp.data.accessToken;
        // Guarda SIEMPRE en la MISMA clave que usa el resto de la app
        localStorage.setItem('token', newT);
        const currentRole = getCurrentRole();
        if (currentRole) localStorage.setItem("role", currentRole);
        else localStorage.removeItem("role");
        const currentUsername = getCurrentUsername();
        if (currentUsername) localStorage.setItem("username", currentUsername);
        else localStorage.removeItem("username");
        orig.headers.Authorization = `Bearer ${newT}`;
        return instance(orig);
      } catch (refreshErr) {
        console.warn("[axios] refresh_failed_clearing_local_session", {
          status: refreshErr?.response?.status,
          message: refreshErr?.response?.data?.message,
        });
        // Si falla, borramos y vamos a login
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('username');
        window.location.href = '/authentication/sign-in';
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export default instance;
